module.exports = __webpack_public_path__ + "static/media/warning.f0446bb9.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/warning.png
// module id = 255
// module chunks = 0